import axios from 'axios'
import token from '@/utils/token.js'
import {
    Message
} from 'view-design'
import store from '@/store.js'
var lz_baseurl = localStorage.getItem("baseURL");

var instance = axios.create({
    // baseURL: '/api',
    baseURL: lz_baseurl,
    // baseURL:'http://192.168.200.220:16002/',//凯宾后台
    // baseURL:'http://115.231.27.22:13005/#/',


    //baseURL: process.env.NODE_ENV === 'development' ? "http://192.168.20.138:9001/api" : "http://36.137.111.34:8001/api", //调试环境
    // baseURL: "http://192.168.1.129:8086/api/",
    timeout: 300000,
});

// localStorage.setItem('baseURL', process.env.NODE_ENV === 'development' ? 'http://192.168.20.138:9001' : 'http://36.137.111.34:8001');


//白名单页面，不拦截
const whitelistPaths = '/token;'
//请求拦截
instance.interceptors.request.use(
    config => {
        //需要拦截的页面d
        if (whitelistPaths.indexOf(config.url) < 0) {
            //添加token
            config.headers.common['Authorization'] = "Bearer " + token.getToken();
        }
        if (config.method === 'get') {
            const qs = require("qs");
            // 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2
            config.paramsSerializer = function (params) {
                return qs.stringify(params, {
                    arrayFormat: 'repeat'
                })
            }
        }
        return config;
    },
    error => {
        console.log(error);
    }
)
//响应拦截
instance.interceptors.response.use(
    response => {
        //默认响应格式{data:{},msg: "成功",statusCode: 200}
        var data = response.data;
        if (data.statusCode == "200"||data.result == "200") {
            return data;
        }
        //主系统已经离线
        if (data.statusCode == "409") {
            Message.error(data.msg)
            setTimeout(() => {
                store.dispatch('loginOut').then(() => {
                    location.reload()
                })
            }, 2000);
        }else {
            Message.error(data.msg||data.message||data.Message||'请求失败，请稍后重试！')
            return false;
        }
    },
    error => {
        let response = error.response;
        console.log('失败响应',response);
        if (response != undefined) {
            let status = response.status;
            let msg = showStatus(status, response.data.errors);
            Message.error(msg);
            if (status == 401) {
                setTimeout(() => {
                    store.dispatch('loginOut').then(() => {
                        location.reload()
                    })
                }, 2000);
            }
            return false;
        } else {
            Message.error("服务器500");
            return false;
        }
    }
)

const showStatus = (status, errors) => {
    let message = ''
    switch (status) {
        case 400:
            message = Object.values(errors)[0][0];
            break
        case 401:
            message = '未登录，或登录失效，请重新登录'
            break
        case 403:
            message = '拒绝访问(403)'
            break
        case 404:
            message = '无法找到请求的资源(404)'
            break
        case 405:
            message = '方法不被允许(405)'
            break
        case 408:
            message = '请求超时(408)'
        case 409:
            message = '主系统已经离线'
            break
        case 500:
            message = '服务器错误(500)'
            break
        case 501:
            message = '服务未实现(501)'
            break
        case 502:
            message = '网络错误(502)'
            break
        case 503:
            message = '服务不可用(503)'
            break
        case 504:
            message = '网络超时(504)'
            break
        case 505:
            message = 'HTTP版本不受支持(505)'
            break
        default:
            message = `连接出错(${status})!`
    }
    return message;
}

export default instance